module.exports = __webpack_public_path__ + "static/media/display09.6a54cd46.jpg";